import * as React from 'react';
import cls from 'classnames';
import { compiler } from 'markdown-to-jsx';

import styles from './index.module.sass';

interface Props {
  children: string;
  className?: string;
  containerElement?: React.ElementType;
  inline?: boolean;
  style?: React.CSSProperties;
}

export const Markdown: React.FC<Props> = ({
  children,
  className,
  containerElement,
  inline = false,
  ...props
}) => {
  if ( !children ) return null;

  const Container = containerElement || ( inline ? 'span' : 'div' );

  return (
    <Container className={cls( className, styles.markdown )} {...props}>
      {compiler( children, { forceInline: inline })}
    </Container>
  );
};
